import Grid2 from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
import { useReactPWAInstall } from "./PWAInstall";

function Home() {
    const retinaMatched = useMediaQuery(
        "(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2)"
    );

    // PWA installation prompt
    const { pwaInstall, supported, isInstalled } = useReactPWAInstall();

    const handleClick = () => {
        pwaInstall({})
            .then(() =>
                console.log(
                    "App installed successfully or instructions for install shown"
                )
            )
            .catch(() => console.log("User opted out from installing"));
    };

    return (
        <Grid2 container>
            <Grid2 xs={12} sx={{ paddingBottom: "6rem" }}>
                <Grid2 xs={10} sx={{ margin: "1rem" }}>
                    <Typography variant="h1">Der HD+ Checker</Typography>
                </Grid2>
                <Box
                    component="div"
                    style={{
                        minHeight: "204px",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "contain",
                        backgroundImage: retinaMatched
                            ? 'url("small-horst@2x.png"), linear-gradient(180deg, #E54628 0%, #E54628 51.04%, #CA3E23 100%)'
                            : 'url("small-horst.png"), linear-gradient(180deg, #E54628 0%, #E54628 51.04%, #CA3E23 100%)',
                    }}
                ></Box>
                <Grid2 xs={10} sx={{ margin: "1rem" }}>
                    <Typography variant="p" component="p">
                        Schnell und einfach prüfen, ob die HD+ TV-App im
                        Fernseher integriert ist.
                    </Typography>
                </Grid2>

                <Grid2 xs={12} sx={{ alignItems: "center" }}>
                    <Stack spacing={2} style={{ margin: "0 14px" }}>
                        <Link to={"scan"}>
                            <Button
                                style={{
                                    backgroundColor: "#202020",
                                    width: "100%",
                                    fontSize: "0.88rem",
                                }}
                                variant="contained"
                            >
                                <Icon
                                    style={{
                                        textAlign: "center",
                                        lineHeight: 1,
                                        width: "1.35rem",
                                        marginRight: "14px",
                                    }}
                                >
                                    <img
                                        src="barcode-icon-white.svg"
                                        alt="Barcode icon"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                        }}
                                    />
                                </Icon>
                                EAN-code scannen
                            </Button>
                        </Link>

                        <Link to={"input"}>
                            <Button
                                style={{
                                    backgroundColor: "#202020",
                                    width: "100%",
                                    fontSize: "0.88rem",
                                }}
                                variant="contained"
                            >
                                <DriveFileRenameOutlineIcon
                                    style={{
                                        marginRight: "14px",
                                        width: "1.4rem",
                                    }}
                                />
                                Modellnummer eingeben
                            </Button>
                        </Link>
                        {!isInstalled() && (
                            <Grid2
                                xs={12}
                                sx={{
                                    alignItems: "center",
                                    borderTop: "1px solid #A1A1A5",
                                    paddingTop: "2rem",
                                }}
                                style={{ marginTop: "2rem" }}
                            >
                                <Button
                                    onClick={handleClick}
                                    style={{
                                        borderColor: "#202020",
                                        color: "#202020",
                                        width: "100%",
                                        fontSize: "0.88rem",
                                    }}
                                    variant="outlined"
                                >
                                    <AddIcon />
                                    HD+ Checker als App nutzen
                                </Button>
                            </Grid2>
                        )}
                    </Stack>
                </Grid2>
            </Grid2>
        </Grid2>
    );
}

export default Home;
